'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fpBranch = undefined;

var _stubTrue2 = require('lodash/stubTrue');

var _stubTrue3 = _interopRequireDefault(_stubTrue2);

var _rearg2 = require('lodash/rearg');

var _rearg3 = _interopRequireDefault(_rearg2);

var _identity2 = require('lodash/identity');

var _identity3 = _interopRequireDefault(_identity2);

var _curry2 = require('lodash/curry');

var _curry3 = _interopRequireDefault(_curry2);

var _cond2 = require('lodash/cond');

var _cond3 = _interopRequireDefault(_cond2);

var _concat2 = require('lodash/concat');

var _concat3 = _interopRequireDefault(_concat2);

exports.branch = branch;
exports.condId = condId;
exports.overBranch = overBranch;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function branch(bool, trueVal, falseVal) {
  return bool ? trueVal : falseVal;
}

// fpBranch(trueVal, falseVal, boolVal)
var fpBranch = exports.fpBranch = (0, _curry3.default)((0, _rearg3.default)(branch, [2, 0, 1]), 3);
// ternary
function condId() {
  for (var _len = arguments.length, conditions = Array(_len), _key = 0; _key < _len; _key++) {
    conditions[_key] = arguments[_key];
  }

  var rules = (0, _concat3.default)(conditions, [[_stubTrue3.default, _identity3.default]]);
  return (0, _cond3.default)(rules);
}
function overBranch(boolCheck, getTrue) {
  var getFalse = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _identity3.default;

  return (0, _cond3.default)([[boolCheck, getTrue], [_stubTrue3.default, getFalse]]);
}


//////////////////
// WEBPACK FOOTER
// ./~/cape-lodash/lib/cond.js
// module id = 302
// module chunks = 0